import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/apiCaller/cl_index";
import { endpoints } from "../../api/ApiEndPoints";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";

const initialState = {
  bonusHistoryData: "",
  bonusLoader: true,
};

export const bonusHistorySlice = createSlice({
  name: "bonusHistory",
  initialState,
  reducers: {
    setBonusHistoryData: (state, action) => {
      state.bonusHistoryData = action.payload;
    },
    setBonusLoader: (state, action) => {
      state.bonusLoader = action.payload;
    },
  },
});

export const { setBonusHistoryData, setBonusLoader } = bonusHistorySlice.actions;

export default bonusHistorySlice.reducer;

export const fetchBonusHistory = (userId, pageNum) => (dispatch) => {
  dispatch(setBonusLoader(true));
  const token = getFromLocalStorage("gk");
  let url = endpoints.bonusHistory;
  const payload = {
    clientType: "mobile",
    accessToken: token,
    itemsPerPage: 10,
    pageNumber: pageNum,
    userId: userId.toString()
  };
  postRequest(url, payload).then((res) => {
    if (res?.status === 200) {
      dispatch(setBonusLoader(false));
      dispatch(setBonusHistoryData(res.data?.result?.data));
    }else{
      dispatch(setBonusLoader(false));
      dispatch(setBonusHistoryData([]))
    }
  });
};
